import React, { useEffect, useRef, useMemo } from "react";
import PropTypes from "prop-types";
import { GRID_COLOR } from "../../constants";

function HorizontalGrid({ height, pBottom, pTop, axisConf }) {
  const canvasRef = useRef(null);
  const ticks = useMemo(() => axisConf?.ticks || [], [axisConf]);

  useEffect(() => {
    const totalHeight = pBottom + pTop + height || 1;
    const canvas = canvasRef.current;
    const ctx = canvas.getContext("2d");
    const pxRatio = window.devicePixelRatio || 1;
    const mainColor = GRID_COLOR;
    const cHeight = totalHeight;

    canvas.width = 1;
    canvas.height = `${cHeight * pxRatio}`;
    canvas.style.width = "100%";
    canvas.style.height = `${cHeight}px`;

    ctx.scale(1, pxRatio);

    ctx.textAlign = "right";
    ctx.textBaseline = "middle";
    ctx.clearRect(0, 0, 1 * pxRatio, totalHeight * pxRatio);

    ctx.beginPath();
    ticks.forEach((d) => {
      ctx.beginPath();
      ctx.lineWidth = 0.5;
      ctx.strokeStyle = d.color || mainColor;
      ctx.fillStyle = d.color || mainColor;
      ctx.moveTo(0, d.y * height + pTop);
      ctx.lineTo(1, d.y * height + pTop);
      ctx.stroke();
      ctx.closePath();
    });
  }, [height, pBottom, pTop, ticks]);

  return <canvas ref={canvasRef} />;
}

HorizontalGrid.propTypes = {
  height: PropTypes.number.isRequired,
  pBottom: PropTypes.number.isRequired,
  pTop: PropTypes.number.isRequired,
  axisConf: PropTypes.shape({
    ticks: PropTypes.arrayOf(PropTypes.shape({})),
  }).isRequired,
};

export default React.memo(HorizontalGrid);
